/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const NOTSET = 'Not Set';
export const ALLOW_ACCESS = 'Yes';
export const DISALLOW_ACCESS = 'No';
export const EDIT_BTN = 'Edit';
export const CLOSE = 'Close';
export const CANCEL_BTN_TEXT = 'Cancel';
export const SAVE = 'Save';
